import React, { ComponentProps } from 'react';
import { TableExpandedRow as CarbonTableExpandedRow } from '@carbon/react';

export type TableExpandedRowProps = ComponentProps<
  typeof CarbonTableExpandedRow
>;

export const TableExpandedRow = (props: TableExpandedRowProps) => (
  <CarbonTableExpandedRow {...props} />
);

TableExpandedRow.displayName = 'TableExpandedRow';
